/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Icon from "../images/golden-gate-icon.png"
import "./layout.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div className="container">
        <main>
          {children}
        </main>
      </div>
      <footer>
        <div className="footer-container">
          <div className="footer-contact">
            <img src={Icon} alt='Golden Gate Pharmacy Icon' className="footer-icon" /><br />
            Contact Us<br />
            P: 415.455.9042<br />
            F: 1.888.974.1552<br />
          </div>
        </div>
      </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
